module.exports = __webpack_public_path__ + "img/truck_large.3e2d0a60.svg";